import { useContext } from 'react';
import { useSlate } from 'slate-react';
import { SidebarContext } from 'app/state/contexts/SidebarContext';
import { insertStyledParagraph } from 'app/slate/extensions/styled-paragraph';
import { v4 as uuidv4 } from 'uuid';
export const AddStyledParagraph = ({ isInsideStyledParagraph }) => {
  const { setStyledParagraph, setIsSidebarOpen } = useContext(SidebarContext);
  const editor = useSlate();

  const handleClick = (e) => {
    e.preventDefault();
    if (isInsideStyledParagraph) {
      setIsSidebarOpen(7);
    } else {
      const styledParagraphId = uuidv4();
      insertStyledParagraph(editor, styledParagraphId);
      setStyledParagraph({ id: styledParagraphId, connected: true });
      setIsSidebarOpen(7);
    }
  };

  return (
    <div className="styled-paragraph--add-paragraph" onMouseDown={handleClick}>
      <i className="fa-regular fa-rectangle-list" />
    </div>
  );
};
